export default __webpack_public_path__ + "static/media/DBLPOP.0fbdc313.mp3";